import { actionConst } from "../constants";

export const updateUserStartDate = (startDate: string) => {
  return {
    type: actionConst.USER_START_DATE,
    startDate,
  };
};
